import { DateTime } from "luxon";

// Masa langganan (GET /api/langganan). Tanggal berlaku sampai akhir hari, WITA, lalu masa tenggang
// LANGGANAN_GRACE_HARI (bawaan 0 sejak 22 Okt 2026 = tanpa tenggang: masa_tenggang selalu false,
// terkunci_pada = berakhir). Bila > 0: masa_tenggang = true, terkunci_pada = hari terakhir tenggang.
// habis = terkunci.
// API lama tidak mengirim masa_tenggang/terkunci_pada: perilakunya tetap seperti sebelum tenggang.
export const BATAS_PERINGATAN_HARI = 14;

export function tanggalPanjang(ymd) {
  return DateTime.fromISO(ymd).setLocale("id").toFormat("cccc, d LLLL yyyy");
}

export function tanggalPendek(ymd) {
  return DateTime.fromISO(ymd).setLocale("id").toFormat("d LLL yyyy");
}

// ok | dekat (<= 14 hari) | genting (<= 3 hari) | tenggang (berakhir, belum terkunci) | habis (terkunci)
export function nada(l) {
  if (!l) return null;
  if (l.habis) return "habis";
  if (l.masa_tenggang) return "tenggang";
  if (l.sisa_hari <= 3) return "genting";
  if (l.sisa_hari <= BATAS_PERINGATAN_HARI) return "dekat";
  return "ok";
}

export function kalimatSisa(sisa) {
  if (sisa < 0) return "sudah berakhir";
  if (sisa === 0) return "hari ini hari terakhir";
  if (sisa === 1) return "berakhir besok";
  return `berakhir ${sisa} hari lagi`;
}

// Hari terakhir sebelum terkunci: hari terakhir tenggang, atau (API lama / tanpa tenggang) hari
// terakhir langganan.
export function besokTerkunci(l) {
  if (!l) return false;
  if (l.masa_tenggang) return l.sisa_hari_tenggang <= 0;
  if (l.sisa_hari_tenggang === undefined || l.sisa_hari_tenggang === null) return l.sisa_hari <= 0;
  return l.sisa_hari_tenggang <= 0;
}

// Kalimat masa tenggang (sesudah berakhir, sebelum terkunci).
export function kalimatTenggang(l) {
  if (besokTerkunci(l)) return "Mulai besok aplikasi terkunci sampai perpanjangan dibayar. Lunasi hari ini.";
  return `Lunasi sebelum ${tanggalPanjang(l.terkunci_pada)} agar aplikasi tidak terkunci.`;
}

export function bukaPanduanLangganan(router) {
  window.open(router.resolve({ name: "panduan-masa-langganan" }).href, "_blank", "noopener");
}

export const PORTAL_DUKUNGAN = "https://support.accutrax.id";
